import React,{useEffect, useState} from 'react'
import PricingCards from '../../../../components/Pricing/PricingCards'
import PricingDetails from '../../../../consts/PricingDetails'
import GetRequest from '../../../../service/GetRequest';
import { useNavigate } from "react-router-dom";
import '../style.css'
import { Button } from 'primereact/button';
import PostRequest from '../../../../service/PostRequest';
import CookieHandler from '../../../LandingPage/Authentication/CookieHandler';

const PackageSelectionPage = () => {

  const navigate = useNavigate();

  const userId = CookieHandler.getCookie("userid");
  const fullName = CookieHandler.getCookie("customerName");
  const email = CookieHandler.getCookie("email");

  const [selectedPackage, setSelectedPackage]= useState();
  const [isSubscribed, setIsSubscribed]= useState(false);
  const [packageDetails,setPackageDetails] = useState(null);

  const chooseAnotherPackage = () => {
    setSelectedPackage(null);
};

const findPackageDetails = (packageName) => {
  const foundPackage = PricingDetails.find(detail => detail.packageName === packageName);
  if (!foundPackage) {
    setSelectedPackage(null);
  }
  return foundPackage;
};


const purchasePackage = async () => {
  const data = {
    applicationId:"Boss",
    packageName: packageDetails.packageName,
    customerName: fullName,
    customerEmail: email,
    paymentInitiatedCountry:"uk",
    subscriptionId: "subscriptionId",
    invoiceNeeded: true,
  };
  console.log("the registered data is", data);

  try {
    const response = await PostRequest('v1/store-management-service/view/manager/subscription/package', data, true);
    console.log(response);
    if (response === undefined) {
      console.log("Purchase API failed");
    } else {
      if (typeof response === 'string') {
        window.location.href = response;
      }
    }
  } catch (error) {
    console.error("purchase request failed:", error);
  }
};


      useEffect (()=>{
        GetRequest("v1/store-management-service/view/manager",true)
        .then(response=>{
            if(!response || response === undefined){
                console.log("Error fetching details");
            } else {
                setSelectedPackage(response.recommendedPlan);
                setIsSubscribed(response.isSubscribed);
                const foundPackage = findPackageDetails(response.recommendedPlan);
                if(foundPackage) {
                  setPackageDetails(foundPackage);
                } else {
                  console.log("Package details not found");
                }
                if(response.isSubscribed===true){
                  navigate("/store");
                }
            }      
        })   
      },[isSubscribed,navigate,userId]);


  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container-max">
          <br/><br/>
        <div className='centralised-text extra-large-text'>
        {selectedPackage ? (<span style={{ fontSize: '30px', color: 'grey' }}>Please proceed with payment</span>):(<span style={{ fontSize: '30px', color: 'grey' }}>Please Select a Package</span>)}</div>
            <br/><br/>
        {selectedPackage && packageDetails ? (
                    <div className="flex-container">
                <div className='package-selection-container'>


                  <div className="package-details-header">
                  <div className='centralised-text'>You have chosen</div><br/><br/>
                    <div className="package-name">{packageDetails.packageName}</div>
                    <div className="package-tagline">{packageDetails.label}</div>
                  </div>
                  <div className="package-details-features">
                    {packageDetails.features && packageDetails.features.map((detail, index) => (
                      <div key={index} className="feature-block">
                        <div className="feature-icon"></div>
                        <div className="feature-name">{detail}</div>
                      </div>
                    ))}
                  </div></div>
                  <div className='centralised-text'>
                  <div className='extra-large-text'>
                  Subscribe for <span style={{ fontSize: '36px', color: 'green' }}>{packageDetails.price} </span>Monthly</div>
                  <br/><div className='centralised-text'><div className="price-action-btn" onClick={() => purchasePackage()}>Continue to payment</div></div>
                  <br/><br/><div className='centralised-text'>--or--</div><br/><br/>
                  <div className='centralised-text'> <Button onClick={chooseAnotherPackage} variant="outlined" label= "Choose Another package"/></div>
                  
                  </div>
            <br/>

              </div>
          ) : (
            <>
            <div className="pricing-cards-container">
              {PricingDetails.map((detail, index) => (
                <PricingCards key={index} packageDetails={detail} customerName={fullName} customerEmail={email} purchaseRequired isSmallsize />
              ))}
            </div></>
          )}
<br/>
        </div></div>
    </div>
  )
}

export default PackageSelectionPage
